import { motion } from "framer-motion";

const IMG =
    "https://images.unsplash.com/photo-1758523671826-d7f8217ffac3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxoYXBweSUyMGNvdXBsZSUyMG1vdmluZyUyMGluJTIwbmV3JTIwaG9tZSUyMGtleXMlMjBzbWlsaW5nfGVufDB8fHx8MTc5MDYwNDYwOHww&ixlib=rb-4.1.0&q=85";

const STEPS = [
    {
        title: "Primera llamada y documentación",
        desc: "Nos cuentas tu caso y nos envías la documentación de forma 100% digital.",
    },
    {
        title: "Análisis de viabilidad",
        desc: "Estudiamos tu capacidad financiera y el importe máximo al que puedes optar.",
    },
    {
        title: "Selección del banco y negociación",
        desc: "Comparamos entidades y negociamos las condiciones en tu nombre.",
    },
    {
        title: "Tasación oficial de la propiedad",
        desc: "Coordinamos la tasación de la vivienda con una sociedad homologada.",
    },
    {
        title: "Aceptación de condiciones y firma FEIN",
        desc: "Revisamos contigo la oferta vinculante, cláusula a cláusula.",
    },
    {
        title: "Firma ante notario y entrega de llaves",
        desc: "Te acompañamos el día de la firma. La casa ya es tuya.",
    },
];

export default function Process() {
    return (
        <section
            id="proceso"
            data-testid="process-section"
            className="relative bg-white py-20 lg:py-28 px-4 sm:px-6 lg:px-8 overflow-hidden"
        >
            <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-16">
                <div className="self-start">
                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-600">
                            Nuestro proceso
                        </p>
                        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A] text-balance">
                            El camino hacia tu hipoteca en pocos pasos
                        </h2>
                        <p className="mt-4 text-slate-600 leading-relaxed max-w-md">
                            Transparencia total de principio a fin: sabrás en
                            qué punto está tu operación en todo momento.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: 0.15 }}
                        className="hidden lg:block mt-10 rounded-[2rem] overflow-hidden border border-slate-200 shadow-xl shadow-slate-200/60 aspect-[16/10]"
                    >
                        <img
                            src={IMG}
                            alt="Familia mudándose a su nueva vivienda"
                            className="w-full h-full object-cover"
                            loading="lazy"
                        />
                    </motion.div>
                </div>

                <div className="relative">
                    <div className="absolute left-[27px] top-2 bottom-2 w-px bg-slate-200" />
                    <div className="space-y-8">
                        {STEPS.map((s, i) => (
                            <motion.div
                                key={s.title}
                                data-testid={`process-step-${i + 1}`}
                                initial={{ opacity: 0, x: 40 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{
                                    duration: 0.55,
                                    delay: i * 0.06,
                                    ease: [0.16, 1, 0.3, 1],
                                }}
                                className="relative flex gap-6 items-start"
                            >
                                <span className="relative z-10 shrink-0 flex items-center justify-center w-14 h-14 rounded-2xl bg-[#1F3B5B] border border-[#1F3B5B] font-mono font-bold text-emerald-400">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div className="rounded-2xl bg-[#F5F7FA] border border-slate-200/80 p-5 flex-1 transition-[background-color,border-color,box-shadow,transform] duration-300 hover:bg-white hover:border-emerald-300/60 hover:shadow-lg hover:shadow-slate-200/60 hover:-translate-y-0.5">
                                    <h3 className="font-display font-semibold text-[#0F172A] text-lg">
                                        {s.title}
                                    </h3>
                                    <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">
                                        {s.desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
